var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"lintel"}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.displayTitle))]),_c('div',[_c('a',{attrs:{"title":_vm.$t('bill.details')},on:{"click":_vm.tryAgain}},[_vm._v("\n        "+_vm._s(_vm.$t('common.change'))+"\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }